import { createQueryKeyStore } from '@lukemorales/query-key-factory'

export const keys = createQueryKeyStore({
  admin_funds: {
    all: null,
    detail: (fundId: string) => [fundId],
    transactions: (
      fundId: string,
      paging?: { limit: number; after?: number },
    ) => [fundId, paging],
    navs: (
      fundId: string,
      where?: { startDate?: string; endDate?: string },
    ) => [fundId, where],
    assetNavs: (
      fundId: string,
      where?: { startDate?: string; endDate?: string; effective_at?: string },
    ) => [fundId, where],
    assets: (fundId: string) => [fundId],
    composition: (fundId: string, executedAt?: string) => [fundId, executedAt],
    assetPrices: null,
  },
  admin_feeders: {
    detail: (feederId: string) => [feederId],
  },
  admin_assets: {
    all: null,
    marketPriceHistory: (fissionTicker: string) => [fissionTicker],
    pricesEffective: (date: string, fissionTicker: string) => [
      date,
      fissionTicker,
    ],
  },
})
